import { render } from "./ToolbarToggleButton.vue?vue&type=template&id=07cf4914"
import script from "./ToolbarToggleButton.vue?vue&type=script&lang=js"
export * from "./ToolbarToggleButton.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__